const postAsync = async (url: string, body: any): Promise<Response> => await fetch(url, {
  method: "POST",
  headers: {
    "Content-Type": "application/json"
  },
  body: JSON.stringify(body)
});

const getAsync = async (url: string): Promise<Response> => await fetch(url, {
  method: "GET"
});

export { postAsync, getAsync };